import {FormSupportRequest} from '../models/forms/form-support-request';
import {ZendeskTicket} from '../models/forms/zendesk-ticket';

export interface SupportRequestTicketContext {
  organizationId: string;
  organizationName: string;
  apiMode: string;
}

export function buildSupportRequestZendeskTicket(
  request: FormSupportRequest,
  context: SupportRequestTicketContext,
): ZendeskTicket {
  const body = `${request.request_content}\n\n\n\`\`\`${JSON.stringify({
    healthsystem_name: request.healthsystem_name,
    version: request.version,
    arch: request.arch,
    os: request.os,
    error: request.error,
    error_description: request.error_description,
    brand_id: request.brand_id,
    portal_id: request.portal_id,
    endpoint_id: request.endpoint_id,
    org_connection_id: request.org_connection_id,
    vault_profile_connection_id: request.vault_profile_connection_id,
    external_id: request.external_id,
    external_state: request.external_state,
    request_id: request.request_id,
  })}\`\`\``;

  return {
    name: request.email,
    email: request.email,
    body,
    subject: `Support Request from ${request.healthsystem_name}`,
    organization_id: context.organizationId,
    organization_name: context.organizationName,
    api_mode: context.apiMode,
  } as ZendeskTicket;
}
